import request from '../../../../request/request';

const getPolicyDetails = ({ name }) => {
  return request({
    url: `/webapi/policy/${name}/details`
  });
};

const editPolicyBasicInfo = ({ name, description, code }) => {
  return request({
    url: `/webapi/policy/${name}/details`,
    method: 'post',
    data: { description, ...code }
  });
};

const assignUsers = ({ name, users }) => {
  return request({
    url: `/webapi/policy/${name}/assign-users`,
    method: 'POST',
    data: { users }
  });
};

const assignGroups = ({ name, groups }) => {
  return request({
    url: `/webapi/policy/${name}/assign-groups`,
    method: 'POST',
    data: { groups }
  });
};

export { getPolicyDetails, editPolicyBasicInfo, assignGroups, assignUsers };
